import React, { createContext, useState, useEffect, useContext } from 'react';
import { getDepartments, createDepartment, updateDepartment, deleteDepartment } from '@services/departmentService';

const DepartmentContext = createContext();

export const DepartmentProvider = ({ children }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const data = await getDepartments();
        setDepartments(data);
      } catch (error) {
        console.error('Error fetching departments:', error);
        setError('Failed to fetch departments data.');
      } finally {
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  const addDepartment = async (departmentData) => {
    try {
      const newDepartment = await createDepartment(departmentData);
      setDepartments([...departments, newDepartment]);
    } catch (error) {
      console.error('Error adding department:', error);
      throw error;
    }
  };

  const editDepartment = async (departmentId, departmentData) => {
    try {
      const updatedDepartment = await updateDepartment(departmentId, departmentData);
      setDepartments(departments.map(department => 
        department.id === departmentId ? updatedDepartment : department
      ));
    } catch (error) {
      console.error('Error updating department:', error);
      throw error;
    }
  };

  const removeDepartment = async (departmentId) => {
    try {
      await deleteDepartment(departmentId);
      setDepartments(departments.filter(department => department.id !== departmentId));
    } catch (error) {
      console.error('Error deleting department:', error);
      throw error;
    }
  };

  return (
    <DepartmentContext.Provider value={{ departments, loading, error, addDepartment, editDepartment, removeDepartment }}>
      {error ? (
        <div className="flex items-center justify-center h-screen">
          <p className="text-red-500">{error}</p>
        </div>
      ) : (
        children
      )}
    </DepartmentContext.Provider>
  );
};

export const useDepartments = () => useContext(DepartmentContext);
